var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaishuikou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_665)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 12,
    height: 7,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 16,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 14,
    height: 5,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaishuikou);
export default __webpack_public_path__ + "static/media/paishuikou.5179eb3272a185e9d97968c4e3f1ebdb.svg";
export { ForwardRef as ReactComponent };